import { cloneDeep } from 'lodash-es'
import { Command } from '@/plugins/cad/module/core/Command'
import type { CADViewManager } from '../manager/CADViewManager'
import type { IPoint } from '../model/common/interface'
import type { IEntity } from '../model/entity'
import { type EntityGrip, EntityGripHandler } from './entityGripHandler'

/**
 * 控制点拖动命令：将实体某控制点移动到目标位置，并支持撤销恢复。
 */
export class UpdateEntityByGripCommand extends Command {
  constructor(
    private readonly entity: IEntity,
    private readonly grip: EntityGrip,
    private readonly targetPoint: IPoint,
    private readonly originalData: Record<string, any>,
    private readonly viewManager: CADViewManager
  ) {
    super()
  }

  /** 执行命令：基于原始数据重放控制点拖动 */
  execute(): void {
    Object.assign(this.entity, cloneDeep(this.originalData))
    EntityGripHandler.applyGrip(this.entity, this.grip, this.targetPoint)
    this.viewManager.updateEntity(this.entity, { updateGeometry: true })
  }

  /** 撤销命令：恢复实体到拖动前的原始状态 */
  undo(): void {
    Object.assign(this.entity, cloneDeep(this.originalData))
    this.viewManager.updateEntity(this.entity, { updateGeometry: true })
  }
}
